const items = ["Use what you have", "Plan what you need", "Track grocery spending", "Repeat weekly"];

export const EditorialMarquee = () => (
  <div className="overflow-hidden border-y border-black/15 py-6 sm:py-8" data-testid="editorial-marquee" aria-hidden="true">
    <div className="marquee flex w-max whitespace-nowrap">
      {[0, 1].map((k) => (
        <div key={k} className="flex shrink-0 items-center">
          {items.map((t, i) => (
            <span key={t} className="font-display flex items-center px-6 text-4xl sm:text-6xl">
              <span className={i % 2 ? "text-outline italic" : ""}>{t}</span>
              <span className="ml-12 inline-block h-3 w-3 rounded-full bg-[var(--tomato)]" />
            </span>
          ))}
        </div>
      ))}
    </div>
  </div>
);
